import React from 'react';
import { Check, Upload, X, Archive, Clock } from 'lucide-react';

interface VersionStatusBadgeProps {
  status: 'uploading' | 'completed' | 'failed' | 'partial';
  isCurrent?: boolean;
  className?: string;
}

const VersionStatusBadge: React.FC<VersionStatusBadgeProps> = ({
  status,
  isCurrent = false,
  className = ''
}) => {
  const getStatusConfig = () => {
    if (isCurrent) {
      return {
        label: 'Current',
        bgColor: 'bg-green-100 dark:bg-green-900/20',
        textColor: 'text-green-800 dark:text-green-400',
        icon: <Check className="w-3 h-3" />
      };
    }

    switch (status) {
      case 'completed':
        return {
          label: 'Archived',
          bgColor: 'bg-gray-100 dark:bg-gray-800',
          textColor: 'text-gray-600 dark:text-gray-400',
          icon: <Archive className="w-3 h-3" />
        };
      case 'uploading':
        return {
          label: 'Uploading',
          bgColor: 'bg-yellow-100 dark:bg-yellow-900/20',
          textColor: 'text-yellow-800 dark:text-yellow-400',
          icon: <Upload className="w-3 h-3" />
        };
      case 'failed':
        return {
          label: 'Failed',
          bgColor: 'bg-red-100 dark:bg-red-900/20',
          textColor: 'text-red-800 dark:text-red-400',
          icon: <X className="w-3 h-3" />
        };
      case 'partial':
        return {
          label: 'Partial',
          bgColor: 'bg-orange-100 dark:bg-orange-900/20',
          textColor: 'text-orange-800 dark:text-orange-400',
          icon: <Clock className="w-3 h-3" />
        };
      default:
        return {
          label: 'Unknown',
          bgColor: 'bg-gray-100 dark:bg-gray-800',
          textColor: 'text-gray-600 dark:text-gray-400',
          icon: <Clock className="w-3 h-3" />
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1 ${config.bgColor} ${config.textColor} ${className}`}>
      {config.icon}
      {config.label}
    </span>
  );
};

export default VersionStatusBadge; 